export const ERROR_TITLE = 'Página no disponible';
export const ERROR_DESCRIPTION = 'No se pudo encontrar la página requerida.';
export const ERROR_DESCRIPTION2 = 'Muchas gracias y disculpe las molestias ocasionadas.';
export const ERROR_LINK_MESSAGE = 'Volver a la página inicial';
